<template>
    <div class="modal-content image_preview_modal">
        <div class="modal-header">
        <h5 class="modal-title">Просмотр {{name}}</h5>
        <button type="button" class="close" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
        </button>
        </div>
        <div class="modal-body">
            <div class="image_preview_modal__body d-flex form-group align-items-center">
              <img :src="imgSrc" :alt="name" width="100%">
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">Закрыть</button>
        </div>
    </div>
</template>

<script>

export default {
  name: 'ImagePreviewModal',
  props: {
    name: {
      type: String,
      required: true
    },
    imgSrc: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .image_preview_modal__body {
    min-height: 400px;
  }
</style>
